import { createConsumer } from "@rails/actioncable";
import { useEffect, useState } from "react";
import { Status } from "../constants";

export interface ChangeQueryStatusPayload {
  status: Status;
  message: string;
  query_id: string;
}

export interface ChangeExportStatusPayload {
  status: Status;
  message: string;
  query_id: string;
  signed_url: string;
}

export function useCable(
  onChangeQueryStatus: (message: ChangeQueryStatusPayload) => void,
  onChangeExportStatus: (message: ChangeExportStatusPayload) => void,
) {
  const [cable] = useState(() => createConsumer("/cable"));
  const [queryChannel] = useState(() => {
    return cable.subscriptions.create(
      { channel: "BigqueryQueryChannel" },
      {
        connected: () => {
          console.log("connected query channel");
        },
        disconnected: () => {
          console.log("disconnected query channel");
        },
        received: (message: ChangeQueryStatusPayload) => {
          onChangeQueryStatus(message);
        },
      },
    );
  });
  const [exportChannel] = useState(() => {
    return cable.subscriptions.create(
      { channel: "BigqueryExportChannel" },
      {
        connected: () => {
          console.log("connected export channel");
        },
        disconnected: () => {
          console.log("disconnected export channel");
        },
        received: (message: ChangeExportStatusPayload) => {
          onChangeExportStatus(message);
        },
      },
    );
  });
  useEffect(() => {
    return () => {
      queryChannel.unsubscribe();
      exportChannel.unsubscribe();
    };
  }, []);
}
